export const translations = {
  pt: {
    locale: 'pt-BR',
    nav: {
      about: "Sobre",
      services: "Serviços",
      differentials: "Diferenciais",
      blog: "Blog",
      contact: "Entrar em Contato"
    },
    hero: {
      title1: "Modernização",
      title2: "Tecnológica",
      title3: "Sem Complicação",
      subtitle: "Transformamos processos empresariais através de soluções tecnológicas inovadoras e personalizadas para cada segmento.",
      prediscovery: "Pré-discovery gratuito",
      endtoend: "Processos end-to-end",
      agile: "Soluções ágeis e exclusivas",
      cta1: "Entrar em Contato",
      cta2: "Conheça a Hack a Tech"
    },
    about: {
      title: "Sobre a Hack a Tech",
      subtitle: "Somos uma consultoria especializada em modernização tecnológica, focada em entregar soluções inovadoras e personalizadas para empresas de todos os segmentos.",
      mission: {
        title: "Nossa Missão",
        description: "Ser uma referência em modernização tecnológica para qualquer segmento, transformando desafios em oportunidades através da tecnologia."
      },
      vision: {
        title: "Nossa Visão",
        description: "Liderar a transformação digital empresarial, capacitando organizações a alcançar seu máximo potencial através de soluções tecnológicas inteligentes."
      },
      differential: {
        title: "Nosso Diferencial",
        description: "Trabalhamos de forma exclusiva para cada situação, desenvolvendo soluções personalizadas que se adaptam perfeitamente às necessidades do seu negócio."
      },
      segments: {
        title: "Segmentos que Atendemos"
      }
    },
    services: {
      title: "Nossos Serviços",
      subtitle: "Oferecemos soluções completas em tecnologia para impulsionar o crescimento e a eficiência da sua empresa.",
      modernization: {
        title: "Modernização Tecnológica",
        description: "Transformamos sistemas legados em soluções modernas e eficientes, aumentando a produtividade e reduzindo custos operacionais.",
        features: ["Análise de sistemas atuais", "Migração segura", "Otimização de performance", "Treinamento de equipes"]
      },
      consulting: {
        title: "Consultoria Estratégica",
        description: "Oferecemos orientação especializada para definir a melhor estratégia tecnológica alinhada aos seus objetivos de negócio.",
        features: ["Diagnóstico completo", "Roadmap tecnológico", "Gestão de mudanças", "Acompanhamento contínuo"]
      },
      cloud: {
        title: "Infraestrutura Cloud AWS",
        description: "Implementamos e gerenciamos soluções em nuvem AWS para garantir escalabilidade, segurança e alta disponibilidade.",
        features: ["Migração para nuvem", "Otimização de custos", "Monitoramento 24/7", "Backup e disaster recovery"]
      },
      development: {
        title: "Desenvolvimento Sob Medida",
        description: "Criamos sistemas personalizados que atendem exatamente às necessidades específicas do seu negócio.",
        features: ["Análise de requisitos", "Desenvolvimento ágil", "Integração de sistemas", "Suporte e manutenção"]
      }
    },
    differentials: {
      title: "Nossos Diferenciais",
      subtitle: "O que nos torna únicos no mercado de consultoria tecnológica e por que empresas confiam na Hack a Tech para seus projetos estratégicos.",
      prediscovery: {
        title: "Pré-discovery Gratuito",
        description: "Oferecemos uma análise inicial completa sem custo, identificando oportunidades e definindo a melhor estratégia para seu projeto."
      },
      endtoend: {
        title: "Processos End-to-End",
        description: "Acompanhamos todo o ciclo do projeto, desde a concepção até a implementação e suporte contínuo, garantindo resultados consistentes."
      },
      agile: {
        title: "Soluções Ágeis",
        description: "Utilizamos metodologias ágeis para entregar valor rapidamente, com iterações constantes e feedback contínuo do cliente."
      },
      exclusive: {
        title: "Abordagem Exclusiva",
        description: "Cada projeto é único. Desenvolvemos soluções personalizadas que se adaptam perfeitamente às particularidades do seu negócio."
      },
      cta: {
        title: "Pronto para Transformar seu Negócio?",
        subtitle: "Agende sua consulta gratuita e descubra como podemos impulsionar sua empresa através da tecnologia.",
        button: "Iniciar Pré-discovery Gratuito"
      }
    },
    blog: {
      title: "Nosso Blog",
      subtitle: "Acompanhe as últimas tendências em tecnologia, insights de mercado e dicas práticas para modernizar seu negócio.",
      readMore: "Ler mais",
      views: "Visualizações",
      viewAll: "Ver todos os artigos",
      backToList: "Voltar para listagem",
      loadingFallback: "Nenhum post encontrado",
      listing: {
        title: "Blog Hack a Tech",
        subtitle: "Fique por dentro das novidades de tecnologia",
        noResults: "Sem resultados"
      },
      errors: {
        loadFailed: "Falha ao retornar os posts"
      },
      filters: {
        all: "Todas",
        any: "Todos",
        language: "Idioma",
        category: "Categoria",
        featured: "Destaque"
      },
      pagination: {
        prev: "Anterior",
        page: "Página",
        next: "Próxima"
      },
      categories: {
        technology: "Tecnologia",
        cloud: "Cloud",
        consulting: "Consultoria",
        development: "Desenvolvimento",
        security: "Segurança",
        automation: "Automação"
      },
      posts: {
        post1: {
          title: "Modernização Tecnológica: Tendências para 2024",
          excerpt: "Descubra as principais tendências tecnológicas que estão moldando o futuro dos negócios e como sua empresa pode se preparar para essas mudanças."
        },
        post2: {
          title: "5 Benefícios da Migração para AWS",
          excerpt: "Entenda como a migração para a nuvem AWS pode transformar sua infraestrutura, reduzir custos e aumentar a escalabilidade do seu negócio."
        },
        post3: {
          title: "Transformação Digital: Uma Abordagem Estratégica",
          excerpt: "Aprenda como desenvolver uma estratégia eficaz de transformação digital que alinhe tecnologia com objetivos de negócio."
        },
        post4: {
          title: "Desenvolvimento Ágil: Melhores Práticas",
          excerpt: "Conheça as metodologias ágeis que aceleram o desenvolvimento de software e garantem entregas de qualidade."
        },
        post5: {
          title: "Segurança de Dados na Era Digital",
          excerpt: "Explore as melhores práticas para proteger dados corporativos e garantir conformidade com regulamentações."
        },
        post6: {
          title: "Automação de Processos Empresariais",
          excerpt: "Descubra como a automação pode otimizar processos, reduzir erros e aumentar a produtividade da sua equipe."
        }
      }
    },
    contact: {
      title: "Entre em Contato",
      subtitle: "Pronto para modernizar sua empresa? Entre em contato conosco e descubra como podemos ajudar a transformar seus processos.",
      form: {
        title: "Solicite sua Consulta Gratuita",
        name: "Nome",
        email: "Email",
        company: "Empresa",
        phone: "Telefone",
        message: "Mensagem",
        namePlaceholder: "Seu nome completo",
        emailPlaceholder: "seu@email.com",
        companyPlaceholder: "Nome da sua empresa",
        phonePlaceholder: "(11) 99999-9999",
        messagePlaceholder: "Conte-nos sobre seu projeto ou necessidade...",
        submit: "Enviar Mensagem",
        sending: "Enviando...",
        success: "✓ Mensagem enviada com sucesso! Entraremos em contato em breve."
      },
      info: {
        title: "Informações de Contato",
        email: "Email",
        phone: "Telefone",
        phoneValue: "Em breve disponível",
        service: "Atendimento",
        serviceValue: "Internacional - Remoto e Presencial"
      },
      prediscovery: {
        title: "Pré-discovery Gratuito",
        description: "Oferecemos uma análise inicial completa sem custo para identificar as melhores oportunidades para seu negócio.",
        features: ["Análise de processos atuais", "Identificação de oportunidades", "Roadmap inicial de modernização"]
      }
    },
    footer: {
      description: "Modernização tecnológica sem complicação. Transformamos processos empresariais através de soluções inovadoras e personalizadas.",
      navigation: "Navegação",
      services: "Serviços",
      servicesList: ["Modernização Tecnológica", "Consultoria Estratégica", "Infraestrutura Cloud AWS", "Desenvolvimento Sob Medida"],
      rights: "Todos os direitos reservados.",
      privacy: "Política de Privacidade",
      terms: "Termos de Uso",
      contact: {
        email: "Email:",
        phone: "Telefone:",
        phoneValue: "Em breve disponível",
        service: "Atendimento: Internacional - Remoto e Presencial"
      }
    },
    segments: [
      "Agronegócio",
      "Financeiro", 
      "Varejo",
      "Saúde",
      "Educação",
      "Seguros",
      "Automotivo"
    ]
  },
  en: {
    locale: 'en-US',
    nav: {
      about: "About",
      services: "Services",
      differentials: "Differentials",
      blog: "Blog",
      contact: "Get in Touch"
    },
    hero: {
      title1: "Technology",
      title2: "Modernization",
      title3: "Without Complexity",
      subtitle: "We transform business processes through innovative and personalized technology solutions for each segment.",
      prediscovery: "Free pre-discovery",
      endtoend: "End-to-end processes",
      agile: "Agile and exclusive solutions",
      cta1: "Get in Touch",
      cta2: "Learn about Hack a Tech"
    },
    about: {
      title: "About Hack a Tech",
      subtitle: "We are a consultancy specialized in technology modernization, focused on delivering innovative and personalized solutions for companies across all segments.",
      mission: {
        title: "Our Mission",
        description: "To be a reference in technology modernization for any segment, transforming challenges into opportunities through technology."
      },
      vision: {
        title: "Our Vision",
        description: "To lead enterprise digital transformation, enabling organizations to reach their maximum potential through intelligent technology solutions."
      },
      differential: {
        title: "Our Differential",
        description: "We work exclusively for each situation, developing personalized solutions that perfectly adapt to your business needs."
      },
      segments: {
        title: "Segments We Serve"
      }
    },
    services: {
      title: "Our Services",
      subtitle: "We offer complete technology solutions to drive your company's growth and efficiency.",
      modernization: {
        title: "Technology Modernization",
        description: "We transform legacy systems into modern and efficient solutions, increasing productivity and reducing operational costs.",
        features: ["Current systems analysis", "Secure migration", "Performance optimization", "Team training"]
      },
      consulting: {
        title: "Strategic Consulting",
        description: "We provide specialized guidance to define the best technology strategy aligned with your business objectives.",
        features: ["Complete diagnosis", "Technology roadmap", "Change management", "Continuous monitoring"]
      },
      cloud: {
        title: "AWS Cloud Infrastructure",
        description: "We implement and manage AWS cloud solutions to ensure scalability, security, and high availability.",
        features: ["Cloud migration", "Cost optimization", "24/7 monitoring", "Backup and disaster recovery"]
      },
      development: {
        title: "Custom Development",
        description: "We create personalized systems that exactly meet your business's specific needs.",
        features: ["Requirements analysis", "Agile development", "Systems integration", "Support and maintenance"]
      }
    },
    differentials: {
      title: "Our Differentials",
      subtitle: "What makes us unique in the technology consulting market and why companies trust Hack a Tech for their strategic projects.",
      prediscovery: {
        title: "Free Pre-discovery",
        description: "We offer a complete initial analysis at no cost, identifying opportunities and defining the best strategy for your project."
      },
      endtoend: {
        title: "End-to-End Processes",
        description: "We accompany the entire project cycle, from conception to implementation and continuous support, ensuring consistent results."
      },
      agile: {
        title: "Agile Solutions",
        description: "We use agile methodologies to deliver value quickly, with constant iterations and continuous client feedback."
      },
      exclusive: {
        title: "Exclusive Approach",
        description: "Each project is unique. We develop personalized solutions that perfectly adapt to your business particularities."
      },
      cta: {
        title: "Ready to Transform Your Business?",
        subtitle: "Schedule your free consultation and discover how we can boost your company through technology.",
        button: "Start Free Pre-discovery"
      }
    },
    blog: {
      title: "Our Blog",
      subtitle: "Stay updated with the latest technology trends, market insights, and practical tips to modernize your business.",
      readMore: "Read more",
      viewAll: "View all articles",
      views: "Views",
      backToList: "Back to list",
      loadingFallback: "Failed to fetch posts",
      listing: {
        title: "Blog Hack a Tech",
        subtitle: "Stay up to date with technology news",
        noResults: "Posts not found"
      },
      errors: {
        loadFailed: "Failed to fetch posts"
      },
      filters: {
        all: "All",
        any: "All",
        language: "Language",
        category: "Category",
        featured: "Featured"
      },
      pagination: {
        prev: "Previous",
        page: "Page",
        next: "Next"
      },
      categories: {
        technology: "Technology",
        cloud: "Cloud",
        consulting: "Consulting",
        development: "Development",
        security: "Security",
        automation: "Automation"
      },
      posts: {
        post1: {
          title: "Technology Modernization: Trends for 2024",
          excerpt: "Discover the main technological trends shaping the future of business and how your company can prepare for these changes."
        },
        post2: {
          title: "5 Benefits of AWS Migration",
          excerpt: "Understand how migrating to AWS cloud can transform your infrastructure, reduce costs, and increase your business scalability."
        },
        post3: {
          title: "Digital Transformation: A Strategic Approach",
          excerpt: "Learn how to develop an effective digital transformation strategy that aligns technology with business objectives."
        },
        post4: {
          title: "Agile Development: Best Practices",
          excerpt: "Discover the agile methodologies that accelerate software development and ensure quality deliveries."
        },
        post5: {
          title: "Data Security in the Digital Era",
          excerpt: "Explore best practices for protecting corporate data and ensuring compliance with regulations."
        },
        post6: {
          title: "Business Process Automation",
          excerpt: "Discover how automation can optimize processes, reduce errors, and increase your team's productivity."
        }
      }
    },
    contact: {
      title: "Get in Touch",
      subtitle: "Ready to modernize your company? Contact us and discover how we can help transform your processes.",
      form: {
        title: "Request Your Free Consultation",
        name: "Name",
        email: "Email",
        company: "Company",
        phone: "Phone",
        message: "Message",
        namePlaceholder: "Your full name",
        emailPlaceholder: "your@email.com",
        companyPlaceholder: "Your company name",
        phonePlaceholder: "+1 (555) 123-4567",
        messagePlaceholder: "Tell us about your project or need...",
        submit: "Send Message",
        sending: "Sending...",
        success: "✓ Message sent successfully! We'll get back to you soon."
      },
      info: {
        title: "Contact Information",
        email: "Email",
        phone: "Phone",
        phoneValue: "Coming soon",
        service: "Service",
        serviceValue: "International - Remote and On-site"
      },
      prediscovery: {
        title: "Free Pre-discovery",
        description: "We offer a complete initial analysis at no cost to identify the best opportunities for your business.",
        features: ["Current process analysis", "Opportunity identification", "Initial modernization roadmap"]
      }
    },
    footer: {
      description: "Technology modernization without complexity. We transform business processes through innovative and personalized solutions.",
      navigation: "Navigation",
      services: "Services",
      servicesList: ["Technology Modernization", "Strategic Consulting", "AWS Cloud Infrastructure", "Custom Development"],
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      contact: {
        email: "Email:",
        phone: "Phone:",
        phoneValue: "Coming soon",
        service: "Service: International - Remote and On-site"
      }
    },
    segments: [
      "Agribusiness",
      "Financial", 
      "Retail",
      "Healthcare",
      "Education",
      "Insurance",
      "Automotive"
    ]
  },
  es: {
    locale: 'es-ES',
    nav: {
      about: "Acerca",
      services: "Servicios",
      differentials: "Diferenciales",
      blog: "Blog",
      contact: "Contactar"
    },
    hero: {
      title1: "Modernización",
      title2: "Tecnológica",
      title3: "Sin Complicaciones",
      subtitle: "Transformamos procesos empresariales a través de soluciones tecnológicas innovadoras y personalizadas para cada segmento.",
      prediscovery: "Pre-descubrimiento gratuito",
      endtoend: "Procesos end-to-end",
      agile: "Soluciones ágiles y exclusivas",
      cta1: "Contactar",
      cta2: "Conoce Hack a Tech"
    },
    about: {
      title: "Acerca de Hack a Tech",
      subtitle: "Somos una consultoría especializada en modernización tecnológica, enfocada en entregar soluciones innovadoras y personalizadas para empresas de todos los segmentos.",
      mission: {
        title: "Nuestra Misión",
        description: "Ser una referencia en modernización tecnológica para cualquier segmento, transformando desafíos en oportunidades a través de la tecnología."
      },
      vision: {
        title: "Nuestra Visión",
        description: "Liderar la transformación digital empresarial, capacitando organizaciones para alcanzar su máximo potencial a través de soluciones tecnológicas inteligentes."
      },
      differential: {
        title: "Nuestro Diferencial",
        description: "Trabajamos de forma exclusiva para cada situación, desarrollando soluciones personalizadas que se adaptan perfectamente a las necesidades de su negocio."
      },
      segments: {
        title: "Segmentos que Atendemos"
      }
    },
    services: {
      title: "Nuestros Servicios",
      subtitle: "Ofrecemos soluciones completas en tecnología para impulsar el crecimiento y la eficiencia de su empresa.",
      modernization: {
        title: "Modernización Tecnológica",
        description: "Transformamos sistemas legacy en soluciones modernas y eficientes, aumentando la productividad y reduciendo costos operacionales.",
        features: ["Análisis de sistemas actuales", "Migración segura", "Optimización de performance", "Capacitación de equipos"]
      },
      consulting: {
        title: "Consultoría Estratégica",
        description: "Ofrecemos orientación especializada para definir la mejor estrategia tecnológica alineada con sus objetivos de negocio.",
        features: ["Diagnóstico completo", "Roadmap tecnológico", "Gestión de cambios", "Acompañamiento continuo"]
      },
      cloud: {
        title: "Infraestructura Cloud AWS",
        description: "Implementamos y gestionamos soluciones en la nube AWS para garantizar escalabilidad, seguridad y alta disponibilidad.",
        features: ["Migración a la nube", "Optimización de costos", "Monitoreo 24/7", "Backup y disaster recovery"]
      },
      development: {
        title: "Desarrollo a Medida",
        description: "Creamos sistemas personalizados que atienden exactamente las necesidades específicas de su negocio.",
        features: ["Análisis de requisitos", "Desarrollo ágil", "Integración de sistemas", "Soporte y mantenimiento"]
      }
    },
    differentials: {
      title: "Nuestros Diferenciales",
      subtitle: "Lo que nos hace únicos en el mercado de consultoría tecnológica y por qué las empresas confían en Hack a Tech para sus proyectos estratégicos.",
      prediscovery: {
        title: "Pre-descubrimiento Gratuito",
        description: "Ofrecemos un análisis inicial completo sin costo, identificando oportunidades y definiendo la mejor estrategia para su proyecto."
      },
      endtoend: {
        title: "Procesos End-to-End",
        description: "Acompañamos todo el ciclo del proyecto, desde la concepción hasta la implementación y soporte continuo, garantizando resultados consistentes."
      },
      agile: {
        title: "Soluciones Ágiles",
        description: "Utilizamos metodologías ágiles para entregar valor rápidamente, con iteraciones constantes y feedback continuo del cliente."
      },
      exclusive: {
        title: "Enfoque Exclusivo",
        description: "Cada proyecto es único. Desarrollamos soluciones personalizadas que se adaptan perfectamente a las particularidades de su negocio."
      },
      cta: {
        title: "¿Listo para Transformar su Negocio?",
        subtitle: "Agende su consulta gratuita y descubra cómo podemos impulsar su empresa a través de la tecnología.",
        button: "Iniciar Pre-descubrimiento Gratuito"
      }
    },
    blog: {
      title: "Nuestro Blog",
      subtitle: "Manténgase actualizado con las últimas tendencias tecnológicas, perspectivas del mercado y consejos prácticos para modernizar su negocio.",
      readMore: "Leer más",
      viewAll: "Ver todos los artículos",
      views: "Visualizaciones",
      backToList: "Volver al listado",
      loadingFallback: "Loading posts",
      errors: {
        loadFailed: "No se pudieron devolver las publicaciones"
      },
      listing: {
        title: "Blog Hack a Tech",
        subtitle: "Manténgase actualizado con las últimas novedades tecnológicas",
        noResults: "Publicaciones no encontradas"
      },
      filters: {
        all: "Todas",
        any: "Todas",
        language: "Idioma",
        category: "Categoria",
        featured: "Destacada"
      },
      pagination: {
        prev: "Anterior",
        page: "Página",
        next: "Próxima"
      },
      categories: {
        technology: "Tecnología",
        cloud: "Cloud",
        consulting: "Consultoría",
        development: "Desarrollo",
        security: "Seguridad",
        automation: "Automatización"
      },
      posts: {
        post1: {
          title: "Modernización Tecnológica: Tendencias para 2024",
          excerpt: "Descubra las principales tendencias tecnológicas que están moldeando el futuro de los negocios y cómo su empresa puede prepararse para estos cambios."
        },
        post2: {
          title: "5 Beneficios de la Migración a AWS",
          excerpt: "Entienda cómo la migración a la nube AWS puede transformar su infraestructura, reducir costos y aumentar la escalabilidad de su negocio."
        },
        post3: {
          title: "Transformación Digital: Un Enfoque Estratégico",
          excerpt: "Aprenda cómo desarrollar una estrategia efectiva de transformación digital que alinee la tecnología con los objetivos de negocio."
        },
        post4: {
          title: "Desarrollo Ágil: Mejores Prácticas",
          excerpt: "Conozca las metodologías ágiles que aceleran el desarrollo de software y garantizan entregas de calidad."
        },
        post5: {
          title: "Seguridad de Datos en la Era Digital",
          excerpt: "Explore las mejores prácticas para proteger datos corporativos y garantizar el cumplimiento de las regulaciones."
        },
        post6: {
          title: "Automatización de Procesos Empresariales",
          excerpt: "Descubra cómo la automatización puede optimizar procesos, reducir errores y aumentar la productividad de su equipo."
        }
      }
    },
    contact: {
      title: "Contactar",
      subtitle: "¿Listo para modernizar su empresa? Contáctenos y descubra cómo podemos ayudar a transformar sus procesos.",
      form: {
        title: "Solicite su Consulta Gratuita",
        name: "Nombre",
        email: "Email",
        company: "Empresa",
        phone: "Teléfono",
        message: "Mensaje",
        namePlaceholder: "Su nombre completo",
        emailPlaceholder: "su@email.com",
        companyPlaceholder: "Nombre de su empresa",
        phonePlaceholder: "+34 123 456 789",
        messagePlaceholder: "Cuéntenos sobre su proyecto o necesidad...",
        submit: "Enviar Mensaje",
        sending: "Enviando...",
        success: "✓ ¡Mensaje enviado con éxito! Nos pondremos en contacto pronto."
      },
      info: {
        title: "Información de Contacto",
        email: "Email",
        phone: "Teléfono",
        phoneValue: "Próximamente disponible",
        service: "Atención",
        serviceValue: "Internacional - Remoto y Presencial"
      },
      prediscovery: {
        title: "Pre-descubrimiento Gratuito",
        description: "Ofrecemos un análisis inicial completo sin costo para identificar las mejores oportunidades para su negocio.",
        features: ["Análisis de procesos actuales", "Identificación de oportunidades", "Roadmap inicial de modernización"]
      }
    },
    footer: {
      description: "Modernización tecnológica sin complicaciones. Transformamos procesos empresariales a través de soluciones innovadoras y personalizadas.",
      navigation: "Navegación",
      services: "Servicios",
      servicesList: ["Modernización Tecnológica", "Consultoría Estratégica", "Infraestructura Cloud AWS", "Desarrollo a Medida"],
      rights: "Todos los derechos reservados.",
      privacy: "Política de Privacidad",
      terms: "Términos de Uso",
      contact: {
        email: "Email:",
        phone: "Teléfono:",
        phoneValue: "Próximamente disponible",
        service: "Atención: Internacional - Remoto y Presencial"
      }
    },
    segments: [
      "Agronegocio",
      "Financiero", 
      "Comercio",
      "Salud",
      "Educación",
      "Seguros",
      "Automotriz"
    ]
  }
};